export const InsertPanel = {
  flow: 'y',
  fontSize: 'Z2',
  padding: 'A+Z Z2',
  gap: 'C',
  overflow: 'hidden auto',
  QuickAddPanel: {},
  Line: {
    margin: '-A -A -Z',
  },
  ImportInInsert: {},
  Line_2: {
    margin: '- -A',
  },
  LibraryFromInsert: {},
  Line_3: {
    margin: '- -A',
  },
  DataSourcesInInsert: {},
  Line_4: {
    margin: '- -A',
  },
  IntegrationsInInsert: {},
};